module.exports = __webpack_public_path__ + "img/Point2.355c5fbe.png";